import React from "react";
import { HiOutlineTag } from "react-icons/hi2";
import ExpenseHeader from "./home/header";
import ExpenseTabel from "./home/table";
import { useDispatch, useSelector } from "react-redux";
import { setOpenDialog } from "../../../app/slices/expenseTypesSlice";
import FormDialog from "../../../components/FormDialog";

const ExpenseTypes = () => {
  const _ExpenseTypes = useSelector((state) => state.expenseTypes);
  const _SearchBody = useSelector((state) => state.expenseTypes.searchBody);

  const dispatch = useDispatch();

  const handlDialog = () => {
    dispatch(setOpenDialog());
  };

  return (
    <FormDialog
      open={_ExpenseTypes.dialog}
      onClose={() => {
        handlDialog();
      }}
      icon={<HiOutlineTag />}
      title="أنواع المصاريف"
      maxWidth='md'
    >
      <ExpenseHeader />
      <ExpenseTabel />
    </FormDialog>
  );
};

export default ExpenseTypes;
